import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { NumberInput } from 'hyperdb-utils';
import SeasonalConditionsEditor from './SeasonalConditionsEditor';

const ConditionsFieldset = ({
  property, conditionsData, onChangeDefaultConditions, onChangeSeasonalConditions, setSeasonalConditionSynchronisation = null,
  toggleModalConflict, indexesSeasonsInConflict, showModalConflict = false,
}) => {
  return (
    <fieldset>
      {
        !property.source_channel || !property.source_channel.settings.receive_conditions
          ? <Tabs defaultActiveKey={1} id="prices-tabs">
              <Tab eventKey={1} title="Default conditions">
                <NumberInput
                  label="Minimum Stay *"
                  name="min_stay"
                  value={ conditionsData.min_stay }
                  onChange={ onChangeDefaultConditions.bind(null, 'min_stay') }
                />
                <NumberInput
                  label="Maximum Stay"
                  name="max_stay"
                  value={ conditionsData.max_stay }
                  onChange={ onChangeDefaultConditions.bind(null, 'max_stay') }
                />
                <NumberInput
                  label="Maximum youngs alone"
                  name="max_youngs_alone"
                  value={ conditionsData.max_youngs_alone }
                  onChange={ onChangeDefaultConditions.bind(null, 'max_youngs_alone') }
                />
              </Tab>
              <Tab eventKey={2} title="Seasons">
                <br/>
                <SeasonalConditionsEditor
                  conditions={ conditionsData.seasonal_conditions || [] }
                  onChange={ onChangeSeasonalConditions }
                  toggleModalConflict={ toggleModalConflict }
                  indexesSeasonsInConflict={ indexesSeasonsInConflict }
                  showModalConflict={ showModalConflict }
                  setSeasonalConditionSynchronisation={ setSeasonalConditionSynchronisation }
                />
              </Tab>
            </Tabs>
          : <h4>Min. stay is defined by the channel { property.source_channel.name }</h4>
      }
    </fieldset>
  );
};

export default ConditionsFieldset;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/ConditionsFieldset.jsx